import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { flexRender } from '@tanstack/react-table';
import { omit } from 'ramda';
import { Tooltip } from '../../../atoms';
import { TableBodyCell } from './TableBodyCell';
export const TableCell = (props) => {
    var _a;
    const { cell, onRowClick, isLoading } = props, rest = __rest(props, ["cell", "onRowClick", "isLoading"]);
    const meta = (_a = cell.column.columnDef.meta) !== null && _a !== void 0 ? _a : {};
    const { disableClick, disableTruncate, rightAlign, grow, tooltip } = meta;
    const tooltipProps = tooltip ? omit(['getValue', 'ref'], tooltip) : undefined;
    const content = flexRender(cell.column.columnDef.cell, cell.getContext());
    return (_jsx(TableBodyCell, Object.assign({ columnId: cell.column.id, grow, rightAlign, disableTruncate, isLoading, onClick: disableClick ? undefined : onRowClick }, rest, { children: tooltip ? (_jsx(Tooltip, Object.assign({}, tooltipProps, { value: tooltip.getValue(cell), children: content }))) : (content) })));
};
//# sourceMappingURL=TableCell.js.map